import { Box, Button, Link,  TextField, Typography } from '@mui/material';
import { useState } from 'react';
import { useIsMutating } from 'react-query'

import { cacheKeys, useAuth, useToken, useUpdateAuthentication } from '../api';
import { colors } from '../constants';

const containerStyle = {
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  height: 'inherit',
};
const headerStyle = { margin: '20px 0px' };
const titleRow = {
  margin: '5px 0px',
  display: 'flex',
  flexDirection: 'row',
};
const subtitleRow = { margin: '5px 0px' };
const imgStyle = { marginRight: '10px' };
const inputStyle = { padding: '5px 10px' };
const continueStyle = Object.assign({ background: colors.BLUE }, inputStyle);
const resetStyle = Object.assign({ background: colors.YELLOW, color: 'black' }, inputStyle);
const controlStyle = {
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  justifyContent: 'space-evenly',
  width: '100%',
  margin: '20px 0px',
};

// TODO: shifts updated settimeout?
const Login = () => {
  const { mutate: authenticate } = useUpdateAuthentication();
  const [phoneNumber, setPhoneNumber] = useState('');
  const [isOtpStep, setIsOtpStep] = useState(false);
  const [isOtpError, setIsOtpError] = useState(false);
  const [idToken, setIdToken] = useState();
  const [otp, setOtp] = useState('');
  const [session, setSession] = useState();
  const { isError: authError, mutateAsync: getAuth } = useAuth();
  const { mutateAsync: getToken } = useToken();
  const isMutating = Boolean(useIsMutating(cacheKeys.token))

  const submitPhoneNumber = async () => {
    try {
      const auth = await getAuth(phoneNumber);
      if (auth.hasOwnProperty('session')) {
        setSession(auth.session);
        setIsOtpStep(true);

        return;
      }

      setIdToken(auth.IdToken);
      setIsOtpStep(true);
    } catch (error) {
      console.log(error);
    }
  }
  const submitOtp = async () => {
    if (idToken) {
      if (otp === '111111') {
        return authenticate(idToken);
      }

      return setIsOtpError(true);;
    }

    try {
      const token = await getToken({ phoneNumber, otp, session });
      authenticate(token);
    } catch (error) {
      setIsOtpError(true);
    }
  }
  const reset = () => {
    setPhoneNumber('');
    setIsOtpStep(false);
    setIsOtpError(false);
    setIdToken();
    setOtp();
    setSession();
  }

  const handlePhoneNumberChange = (event) => {
    const { target: { value } } = event
    if (/^\d+$/.test(value) || value.length === 0) {
      setPhoneNumber(value)
    }
  }

  const handleOtpChange = (event) => {
    const { target: { value } } = event
    if (/^\d+$/.test(value) || value.length === 0) {
      setOtp(value)
      setIsOtpError(false)
    }
  }

  const formattedPhoneNumber = `(${phoneNumber.slice(0, 3)}) ${phoneNumber.slice(3, 6)}-${phoneNumber.slice(6)}`;

  return (
    <Box sx={containerStyle}>
      <Box sx={headerStyle}>
        <Box sx={titleRow}>
          <img style={imgStyle} src="/favicon.ico" alt="Intercon Security Logo" />
          {!isOtpStep && <Typography variant="h5" align="center">Request Shifts</Typography>}
          {isOtpStep && <Typography variant="h5" align="center">Enter the verification code.</Typography>}
        </Box>
        <Box sx={subtitleRow}>
          {!isOtpStep && <Typography variant="subtitle" align="center">Enter your phone number to continue</Typography>}
          {isOtpStep && <Typography variant="subtitle" align="center">{`The code was sent to ${formattedPhoneNumber}`}</Typography>}
        </Box>
      </Box>
      {!isOtpStep && <TextField
        type="tel"
        value={phoneNumber}
        onChange={handlePhoneNumberChange}
        disabled={isOtpStep}
        placeholder="5555555555"
        sx={inputStyle}
        label="10 Digit Phone Number"
        error={authError}
        helperText={authError && <span>Phone number not found.</span>}
      />}
      {isOtpStep && <TextField
        type="tel"
        value={otp}
        onChange={handleOtpChange}
        disabled={!isOtpStep}
        placeholder="123456"
        sx={inputStyle}
        label="One Time Password"
        autoComplete="off"
        error={isOtpError}
        helperText={isOtpError && <span>One time pin is incorrect.<br />Please reenter or request a new pin.</span>}
      />}
      <Box sx={controlStyle}>
        <Button onClick={reset} sx={resetStyle} variant="contained">Reset</Button>
        {!isOtpStep && <Button
          onClick={submitPhoneNumber}
          disabled={phoneNumber.length !== 10 || isMutating}
          sx={continueStyle}
          variant="contained">
          Continue
        </Button>}
        {isOtpStep && <Button
          onClick={submitOtp}
          disabled={otp.length !== 6}
          sx={continueStyle}
          variant="contained">
          Continue
        </Button>}
      </Box>
      {isOtpStep && <Typography>Didn't see the code? <Link onClick={submitPhoneNumber}>Send Again.</Link></Typography>}
    </Box>
  );
};

export default Login;
